import React from 'react';
import { isReskin } from '../config/siteVariant';
import LoginPageLegacy from './LoginPageLegacy';
import LoginPageReskin from './LoginPageReskin';

/**
 * LoginPage variant selector. Renders the re-skin login only on a build
 * compiled with REACT_APP_SITE_VARIANT=reskin; otherwise the legacy
 * production login. See src/config/siteVariant.js.
 */
const LoginPage = (props) =>
  isReskin ? <LoginPageReskin {...props} /> : <LoginPageLegacy {...props} />;

export default LoginPage;
